import { useReveal } from "@/hooks/useReveal";

const ROWS = [
  { label: "Default Incoterm", value: "FOB Cartagena or Buenaventura, Colombia" },
  { label: "Alternative Incoterm", value: "CIF Cape Town or Durban, quoted on request" },
  { label: "Container", value: "40 ft container, approximately 20 tonnes" },
  { label: "Minimum for direct import", value: "Half a container as a minimum" },
  { label: "Labelling", value: "Adapted to South African labelling requirements, with the local importer's details, agreed before the run" },
  { label: "Documentation per shipment", value: "Organic certificates, certificate of analysis, phytosanitary and pallet documentation" },
];

export default function ExportDetail() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-2xl">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            The logistics detail, for whoever asks for it
          </h2>
        </div>

        <div className="mt-12 max-w-3xl">
          <div className="border border-cream-dark/60 rounded-lg overflow-hidden">
            {ROWS.map((row, i) => (
              <div
                key={row.label}
                className={`grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-6 px-6 py-4 ${
                  i % 2 === 1 ? "bg-cream/60" : "bg-white"
                }`}
              >
                <div className="text-ink/60 text-sm font-semibold sm:font-medium sm:text-[15px]">
                  {row.label}
                </div>
                <div className="text-ink text-[17px] leading-relaxed">
                  {row.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}